import { render, staticRenderFns } from "./PaymentSuccessPage.vue?vue&type=template&id=248c25d0&"
import script from "./PaymentSuccessPage.vue?vue&type=script&lang=js&"
export * from "./PaymentSuccessPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports